<template>
    <i :class="{ [`uk-icon-${glyph}`]: true, [`uk-icon-${size}`]: true, 'uk-icon-spin': spin }"></i>
</template>

<script type="text/javascript">
export default {
    name: "OpenIcon",
    props: {
        glyph: {
            type: String,
            required: true
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|medium|large)$/),
            default: "normal"
        },
        spin: {
            type: Boolean,
            default: false
        }
    }
}
</script>
